var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound-container"},[_c('div',{staticStyle:{"text-align":"center","width":"80%"}},[_c('Icon',{staticClass:"iconZanwu",attrs:{"type":"iconzanwu"}}),_c('div',{staticClass:"zanwuContent"},[_vm._v("未找到相关界面")]),_c('button',{staticClass:"button-bottom",on:{"click":_vm.backToHome}},[_vm._v("回到首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }